import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";
const tooltipStyle = {
  contentStyle: { background: "#0d0d0d", border: "1px solid #00ff9033", borderRadius: 8, fontSize: 11 },
  labelStyle: { color: "#00ff90" },
};

const COLORS = ["#00ff90","#60a5fa","#c084fc","#fbbf24","#f87171","#34d399","#fb923c"];
function fmt(n) { return `₹${n >= 100000 ? `${(n/100000).toFixed(1)}L` : `${(n/1000).toFixed(0)}k`}`; }

export default function CostByDept({ month }) {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${API}/api/admin/payroll/cost-by-dept?month=${month}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => setData(Array.isArray(d) ? d : d?.data || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [month]);

  if (loading) return (
    <div className={`${card} p-5`}>
      <div className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium mb-4">Cost by Department</div>
      <div className="h-36 rounded-lg bg-white/5 animate-pulse" />
    </div>
  );

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Cost by Department</span>
      </div>
      <div className="p-5">
        {data.length === 0 ? (
          <p className="text-white/20 text-sm italic text-center py-4">No data available.</p>
        ) : (
          <>
            <ResponsiveContainer width="100%" height={120}>
              <BarChart data={data} layout="vertical" margin={{ top: 0, right: 10, left: 0, bottom: 0 }}>
                <XAxis type="number" tick={{ fontSize: 9, fill: "rgba(255,255,255,0.25)" }} tickFormatter={fmt} />
                <YAxis type="category" dataKey="dept" tick={{ fontSize: 10, fill: "rgba(255,255,255,0.4)" }} width={70} />
                <Tooltip {...tooltipStyle} formatter={v => [fmt(v), "Cost"]} />
                <Bar dataKey="cost" radius={[0,3,3,0]}>
                  {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} fillOpacity={0.75} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
            <div className="mt-3 space-y-1.5">
              {data.map((d, i) => (
                <div key={i} className="flex items-center justify-between text-xs">
                  <div className="flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full" style={{ background: COLORS[i % COLORS.length] }} />
                    <span className="text-white/50">{d.dept}</span>
                  </div>
                  <span className="text-white/70 font-medium">{fmt(d.cost)}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}